import axios from "axios";
import Qs from "qs";
import Element from "element-ui";
import Vue from "vue";
import store from '../store'
import until from '../assets/js/until'


const httpServe = (method, url, data, {
  isLoadd = true,
  headersConfig = { "Content-type": 'application/x-www-form-urlencoded;charset=UTF-8' },
  options = {},
  isQs = true
} = {}) => {
  let Public = { //公共参数

  },
    headers = {
      'X-Requested-With': 'XMLHttpRequest',
      "Cache-Control": "must-revalidate",
      "If-Modified-Since": "0",
    }
  headers.token = store.state.userInfo ? store.state.userInfo.userToken : ''
  headers = Object.assign(headers, headersConfig)
  let httpDefaultOpts = { //http默认配置
    method: method,
    // baseURL: mainUrl,
    url: url,
    timeout: 30000,
    withCredentials: true,
    isLoadd: isLoadd,//是否显示加载动画
    params: Object.assign(Public, data),
    data: isQs ? Qs.stringify(data) : data,
    headers
  }
  httpDefaultOpts = Object.assign(options, httpDefaultOpts)
  if (method == 'get') {
    delete httpDefaultOpts.data
    if (!!window.ActiveXObject || "ActiveXObject" in window) {//兼容某些IE get 请求会从缓存拿数据问题
      if (httpDefaultOpts.url.indexOf('?') != '-1') {
        httpDefaultOpts.url = httpDefaultOpts.url + '&timeStapIE=' + new Date().getTime()
      } else {
        httpDefaultOpts.url = httpDefaultOpts.url + '?timeStapIE=' + new Date().getTime()
      }
    }
  } else {
    delete httpDefaultOpts.params
  }

  let promise = new Promise(function (resolve, reject) {
    axios(httpDefaultOpts).then(
      (res) => {
        resolve(res)
      }
    ).catch(
      (response) => {
        reject(response)
      }
    )

  })
  return promise
}

let loading;
function startLoading() {
  loading = Vue.prototype.$loading({
    lock: true,
    background: 'rgba(255, 255, 255, 0.5)',
    // target: document.querySelector(".loading-area") //设置加载动画区域
  });
}

function endLoading() {
  loading.close();
}


//声明一个对象用于存储请求个数
let needLoadingRequestCount = 0;
function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading();
  }
  needLoadingRequestCount++;
}
function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    endLoading();
  }
}
// 新增请求拦截器
axios.interceptors.request.use(
  config => {
    if (config.isLoadd) {
      showFullScreenLoading();
    }
    return config;
  },
  error => {
    tryHideFullScreenLoading();
    Element.Message.error({ message: "请求超时!" });
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    tryHideFullScreenLoading();
    let { data } = response;
    if (data.code && data.code != 0 && data.code != 20000) {
      Element.Message({
        type: 'error',
        center: true,
        message: data.msg
      })
    }
    if (data.code === 401) {
      if (localStorage.getItem("system")) {
        until.methods.goHomee(localStorage.getItem("system"))
      } else {
        window.location.href = '/#/login'
      }
    }
    return data;
  },
  error => {
    tryHideFullScreenLoading();
    if (error.response && error.response.data) {
      Element.Message({
        type: 'error',
        message: `code:${error.response.status},${error.response.data.message}`
      })
    } else {
      Element.Message({
        type: 'error',
        message: error.message
      })

    }
  }
);

export default httpServe;